const API_KEY = import.meta.env.VITE_WEATHER_API_KEY;
const BASE_URL = 'https://api.weatherapi.com/v1';

export interface WeatherResponse {
  current: {
    temp_c: number;
    condition: {
      text: string;
      icon: string;
    };
    wind_kph: number;
    precip_mm: number;
    humidity: number;
  };
}

export interface ForecastDay {
  date: string;
  day: {
    maxtemp_c: number;
    mintemp_c: number;
    avgtemp_c: number;
    condition: {
      text: string;
      icon: string;
    };
    maxwind_kph: number;
    totalprecip_mm: number;
    avghumidity: number;
    daily_chance_of_rain: number;
  };
  hour: Array<{
    time: string;
    temp_c: number;
    condition: {
      text: string;
      icon: string;
    };
    wind_kph: number;
    humidity: number;
    chance_of_rain: number;
  }>;
}

export interface ForecastResponse {
  current: WeatherResponse['current'];
  forecast: {
    forecastday: ForecastDay[];
  };
}

export async function getCurrentWeather(): Promise<WeatherResponse> {
  try {
    const response = await fetch(
      `${BASE_URL}/current.json?key=${API_KEY}&q=Molde&aqi=no`
    );
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error?.message || 'Failed to fetch weather data');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Weather API Error:', error.message);
    } else {
      console.error('Weather API Error:', error);
    }
    throw error;
  }
}

export async function getForecast(): Promise<ForecastResponse> {
  try {
    const response = await fetch(
      `${BASE_URL}/forecast.json?key=${API_KEY}&q=Molde&days=2&aqi=no`
    );
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error?.message || 'Failed to fetch forecast data');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Weather API Error:', error.message);
    } else {
      console.error('Weather API Error:', error);
    }
    throw error;
  }
}
